/**
 * @generated SignedSource<<7f882e4b0fab029aaf54d742aa38f155>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly structureDefinition: {
    readonly startConfigs?: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment">;
    }>;
  };
  readonly " $fragmentType": "SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment";
};
export type SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment$key = {
  readonly " $data"?: SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "startConfigs",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "7c18cc795f54a5d2c5be8351ec977382";

export default node;
